<template>
    <main class="MainCon bottom0">
        <div class="ml7 mr7 mt10" v-if="goodsData.num_iid > 0">
            <div class="myContentBox pb10 pt5">
                <div class="ml7 mr7">
                    <div class="flexBox flexBetween">
                        <div class="f10 b lh30">分享文案</div>
                        <button type="button" ref="copy" id="copy_text" class="mt3"
                                data-clipboard-target="#goodsContent"
                                :class="{'shareBlockBtn_damai':styleName === 'main','shareBlockBtn_damai_yellow':styleName === 'main_b','shareBlockBtn_damai_green':styleName === 'main_c'}"
                                v-on:click="copy('#copy_text')"><em
                                class="iconfont icon-fuzhi"></em>&nbsp;仅复制分享文案
                        </button>
                    </div>
                    <div class="mt7"
                         :class="{'shareAreaBox_damai':styleName === 'main','shareAreaBox_damai_yellow':styleName === 'main_b','shareAreaBox_damai_green':styleName === 'main_c'}"
                         id="shareContent">
                        <div id="goodsContent" class="pl5 pr5" v-html="goodsContent" />
                    </div>
                </div>
            </div>
            <div class="mt12 mb30">
                <div :class="{'myBtn_damai':styleName === 'main','myBtn_damai_yellow':styleName === 'main_b','myBtn_damai_green':styleName === 'main_c'}"
                     v-on:click="createPic">生成长图
                </div>
            </div>
            <div class="myHeight">&nbsp;</div>
        </div>
        <div class="ml7 mr7" v-else>
            <div class="flexBox flexBetween mt10">
                <div class="flexBox-cell-50">
                    <div class="loading-myTitle"></div>
                </div>
                <div class="flexBox-cell-50 tr">
                    <div class="loading-myTitle"></div>
                </div>
            </div>
            <div class="loading-shareAreaBox mt10"></div>
            <p class="mt8"><span class="loading-menuTitle"></span></p>
            <div class="loading-inlineblock mt10"></div>
            <div class="myHeight">&nbsp;</div>
        </div>
    </main>
</template>

<script>
    import Clipboard from "clipboard";
    import {showTip} from "../../libs/utils";

    export default {
        props: {
            id: {
                type: Number,
            },
            styleName: {
                type: String,
                default: 'main'
            },
            goodsData: {
                type: Object,
                default() {
                    return {
                        num_iid: 0,
                        coupon_after_price: '0.00',
                        zk_final_price: '0.00',
                        title: '',
                    }
                }
            },
            tpwd: {
                type: String,
                default: ''
            }
        },
        computed: {
            goodsContent() {
                return this.goodsData.title + '<br>【原价】'
                    + this.goodsData.zk_final_price + '元<br>'
                    + '【券后】' + this.goodsData.coupon_after_price + '元<br>'
                    + '【复制此信息打开手机淘宝即可查看并下单】<br>'
                    + this.tpwd + '<br>【必买理由】'
                    + this.goodsData.guide_content;
            },
        },
        methods: {
            copy: function (id) {
                let clipboard = new Clipboard(id);

                clipboard.on('success', () => {
                    showTip('复制成功');
                    clipboard.destroy()
                })
                clipboard.on('error', () => {
                    showTip('该浏览器不支持自动复制');
                    clipboard.destroy()
                })
            },
            createPic: function () {
                const route = {
                    name: 'top-create-pic',
                    query: {
                        id: this.id
                    }
                };
                this.$router.push(route);
            }
        }
    }
</script>

<style scoped>
    #goodsContent {
        width: 100%;
    }
</style>
